import {Component, Output, EventEmitter, Input} from '@angular/core';
import { ExportToCsv } from 'export-to-csv';

import { Rule, CDSNode } from '../services/capd.model';
import { OrgService } from '../services/org.service';

@Component({
  selector: 'group-delete-rules',
  templateUrl: './group-delete-rules.component.html',
  // inputs: [ 'rules', 'org', 'data' ]
})

/**
 * Deletes rules fom a group.
 */
export class GroupDeleteRulesComponent {
  @Output() ruleDeleted = new EventEmitter();
  isDisabled = true;
  @Input() rules: Rule[];
  @Input() org: CDSNode;
  @Input() data: any;

  constructor(private _service: OrgService) { }

  /**
   * Toggles checkbox that disables the delete button by default.
   *
   * @func toggleDisabled
   */
  toggleDisabled() {
    this.isDisabled = !this.isDisabled;
  }

  /**
   * Deletes the selected rules.
   *
   * @async
   * @func onDelete
   */
  onDelete() {
    this._service.deleteRulesForGroup(this.rules, this.org.extensionId, this.org.rootId)
      .then(res => this.ruleDeleted.emit(null));
  }

  /**
   * Exports a CSV of the rules saved to this group, so they can be re-added later.
   *
   * @func exportCsv
   */
  exportCsv() {
    // new Angular2CsvModule();
    // new Angular2Csv(this.data, this.org.description + '_Rules');
    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: 'Company Package Export CSV',
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true
    };

    const csvExporter = new ExportToCsv(options);

    csvExporter.generateCsv(this.data);
  }

}
